/* eslint-disable */
import axios from 'axios'
import config from '@/config'
import {isFailed} from '@/shared/api.utils'
import {_localize} from '@/utils/i18n'


function slugifyContentDict(data) {
  let result = {}
  for (let languageName in data) {
    for (let sectionName in data[languageName]) {
      for (let contentName in data[languageName][sectionName]) {
        let contentObject = data[languageName][sectionName][contentName]
        let languageSlug = contentObject.language.slug
        let sectionSlug = contentObject.section.slug
        let contentSlug = contentObject.slug
        if (!(languageSlug in result)) {
            result[languageSlug] = {}
        }
        if (!(sectionSlug in result[languageSlug])) {
            result[languageSlug][sectionSlug] = {}
        }
        result[languageSlug][sectionSlug][contentSlug] = contentObject.default
      }
    }
  }
  return result
}

const contentModule = {
  namespaced: true,
  state: {
    all: null,
    slugified: null
  },
  mutations: {
    initContent (state) {
      let localStorageContent = localStorage.getItem('content')
      if (localStorageContent) {
        state.slugified = JSON.parse(localStorageContent)
      }
    },
    updateContent(state, payload) {
      state.all = payload
      state.slugified = slugifyContentDict(payload)
      localStorage.content = JSON.stringify(state.slugified)
    },

    updateSingleContent(state, payload) {
      if (payload.newValue === payload.oldValue) {
        console.log('payload.newValue === payload.oldValue')
        return;
      }
      console.log('updateSingleContent', payload)
      let content = payload.content

      if (content.overridden) {
        content.overridden.value = payload.newValue
      } else {
        content.overridden = {value: payload.newValue}
      }
    }
  },
  actions: {
    saveSingleContent(context, payload) {
      if (payload.newValue === payload.oldValue) {
        console.log('payload.newValue === payload.oldValue')
        return;
      }
      console.log('saveSingleContent', payload)
      let content = payload.content

      let dataToSend =  {
        token: localStorage.carrierToken,
        id: content.id,
        value: payload.newValue
      }

      let promise = axios.post(`${config.url}/company/${payload.companyId}/set_carrier_content/`, dataToSend)

      console.log('payload', payload)

      context.commit('updateSingleContent', payload)

      return promise
    },
    load: function (context, payload) {
      console.log('Loading content...')
      context.commit('updateContent', null)
      return new Promise((resolve, reject) => {
        let data
        let url
        url = config.url
        data = {
          token: localStorage.carrierToken
        }
        let promise = axios.post(`${config.url}/company/${payload.companyId}/get_carrier_content/`, data)
        promise.then((response) => {
          if (isFailed(response)) {
            reject(response)
            return
          }

          // success
          context.commit('updateContent', response.data.data)

          resolve(response)
        })
        promise.catch((e) => {
          reject(e)
        })
      })
    },
  },
  getters: {
    i18n: (state) => (path, args) => {
      return _localize(state.slugified, 'english', path, args)
    },
  },
}

export default contentModule
